import Loan from "typedef/Loan";
import HELOCOffer from "./HELOCOffer";
import HELOANOffer from "./HELOANOffer";
import CLoader from "components/CLoader";
import { Fragment, useCallback, useEffect, useRef, useState } from "react";
import useUser from "context/UserCustomer/useUserCustomerContext";
import { Session as TalkjsSession } from "talkjs/all";
import { Popup, Session } from "@talkjs/react";
import Talk from "talkjs";
import getEnvVariable from "env";
import { getTalkjsToken } from "utils/talkJs";

const FinalOffer = () => {
  const { loan: loanContext } = useUser();

  const [loan, setLoan] = useState<Loan>();
  const [loading, setLoading] = useState(false);

  const loadedLoan = useRef(false);
  const { user } = useUser();

  useEffect(() => {
    if (loanContext && !loadedLoan.current) {
      setLoading(true);
      setLoan(loanContext);
      setLoading(false);
      loadedLoan.current = true;
    }
  }, [loanContext]);

  /*** TalkJS callbacks ***/
  const syncUser = useCallback(() => {
    const email = loan?.borrowerEmail;

    return new Talk.User({
      id: loan?.borrowerId as string,
      name: loan?.borrowerFirstName || "Borrower",
      email,
      role: "borrower",
      phone: user?.isMobile && user?.phoneNumber ? [user?.phoneNumber] : null,
    });
  }, [
    loan?.borrowerEmail,
    loan?.borrowerFirstName,
    loan?.borrowerId,
    user?.isMobile,
    user?.phoneNumber,
  ]);

  const syncConversation = useCallback(
    (session: TalkjsSession) => {
      const conversation = session.getOrCreateConversation(loan?.id as string);

      conversation.setParticipant(session.me);

      return conversation;
    },
    [loan?.id],
  );
  /*** End TalkJS callbacks ***/

  return (
    <Fragment>
      <CLoader loading={loading} />
      {loan && loan.loanType === "HELOAN" && <HELOANOffer />}
      {loan && loan.loanType === "HELOC" && <HELOCOffer />}
      {loan && (
        <Session
          appId={getEnvVariable("TALKJS_APP_ID")}
          syncUser={syncUser}
          tokenFetcher={getTalkjsToken}
        >
          <Popup
            syncConversation={syncConversation}
            showCloseInHeader={true}
            messageField={{
              visible:
                loan?.borrowerSteps?.fundingVerification?.status !== "success",
            }}
          />
        </Session>
      )}
    </Fragment>
  );
};

export default FinalOffer;
